import { filterDefinedListings } from "../enforceTypes/listing";
import store from "./store";


export function retrieveListingFromStore(listingId: number)
{
  const state = store.getState();

  let listing;

  // Try retrieve listing (for currency symbol) from store
  const listings = state.listings.listings || [];
  const listingRows = listings.filter(l => l.listingId === listingId);
  if(listings.length)
    listing = listingRows[0];

  // Try retrieve listing from protocol in store (& saving rows)
  const allProtocolRows = state.protocol.protocols.map(p => p.dosings || []).flat();
  const rowsWithListing = allProtocolRows.filter(r => r?.listingId === listingId);
  if(filterDefinedListings(rowsWithListing).length)
    listing = filterDefinedListings(rowsWithListing)[0];

  const listingSavingRowsWithListing = allProtocolRows
    .map(r => r.listingSavings || []).flat()
    .filter(ls => ls.listingId === listingId);
  if(listingSavingRowsWithListing.length)
    listing = listingSavingRowsWithListing[0];

  const bundleRowsWithListing = allProtocolRows
    .map(r => r?.bundleSavings || []).flat()
    .map(bs => bs.bundle).flat()
    .filter(br => br.listingId === listingId);
  if(filterDefinedListings(bundleRowsWithListing).length)
    listing = bundleRowsWithListing[0];

  return listing;
}